<template>
  <b-modal v-model="isActive" has-modal-card>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title title-success">Bulk Comment</p>
      </header>
      <section class="modal-card-body">
        <b-field label="Comment">
          <b-input
            required
            v-model="form['comment']"
            maxlength="300"
            type="textarea"
          ></b-input>
        </b-field>
      </section>
      <footer class="modal-card-foot">
        <b-button label="Cancel" class="is-normal" @click="cancel" />
        <b-button slot="right" type="is-primary" @click="confirm">
          Save
        </b-button>
      </footer>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "BulkComment",
  props: {
    isActive: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isModalActive: false,
      form: {}
    };
  },
  methods: {
    cancel() {
      this.form = {};
      this.$emit("cancel");
    },
    confirm() {
      if (!this.form["comment"]) {
        this.$buefy.dialog.alert({
          title: "Warning",
          message: "please add your comment",
          type: "is-danger",
          ariaRole: "alertdialog",
          ariaModal: true
        });

        return false;
      } else {
        this.$emit("confirm", this.form.comment);
      }
    }
  },
  watch: {
    isActive(newValue) {
      this.isModalActive = newValue;
    },
    isModalActive(newValue) {
      if (!newValue) {
        this.cancel();
      }
    }
  }
};
</script>
